const data = {
	"width": 640,
	"height": 512,
	"body": "<path fill=\"currentColor\" d=\"M623.2 192c-51.8 3.5-125.7 54.7-163.1 71.5c-29.1 13.1-54.2 24.4-76.1 24.4c-22.6 0-26-16.2-21.3-51.9c1.1-8 11.7-79.2-42.7-76.1c-25.1 1.5-64.3 24.8-169.5 126L192 182.2c30.4-75.9-53.2-151.5-129.7-102.8L7.4 116.3C0 121-2.2 130.9 2.5 138.4l17.2 27c4.7 7.5 14.6 9.7 22.1 4.9l58-38.9c18.4-11.7 40.7 7.2 32.7 27.1L34.3 404.1C27.5 421 37 448 64 448c8.3 0 16.5-3.2 22.6-9.4c42.2-42.2 154.7-150.7 211.2-195.8c-2.2 28.5-2.1 58.9 20.6 83.8c15.3 16.8 37.3 25.3 65.5 25.3c35.6 0 68-14.6 102.3-30c33-14.8 99-62.6 138.4-65.8c8.5-.7 15.2-7.3 15.2-15.8v-32.1c.2-9.1-7.5-16.8-16.6-16.2z\"/>"
};
exports.__esModule = true;
exports.default = data;
